/* Hero 3D — pointer / tilt parallax and offscreen pause. Tiny, dependency-free. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    var scene = section.querySelector('[data-h3d-scene]');
    if (!scene) return;

    // Pause all animation while the banner is off screen (saves battery on phones).
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { section.classList.toggle('is-paused', !e.isIntersecting); });
      }, { threshold: 0.02 }).observe(section);
    }
    if (reduce) return;

    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
    function loop() {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      scene.style.setProperty('--ry', (cx * 14).toFixed(2) + 'deg');
      scene.style.setProperty('--rx', (cy * -8).toFixed(2) + 'deg');
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) raf = requestAnimationFrame(loop); else raf = null;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(loop); }

    section.addEventListener('pointermove', function (e) {
      var r = section.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      kick();
    }, { passive: true });
    section.addEventListener('pointerleave', function () { tx = 0; ty = 0; kick(); });

    // Gentle scroll tilt on touch devices, where there is no hover pointer.
    if (window.matchMedia('(hover: none)').matches) {
      window.addEventListener('scroll', function () {
        var r = section.getBoundingClientRect();
        var p = Math.max(-1, Math.min(1, r.top / (r.height || 1)));
        ty = p * -0.8; tx = p * 0.4; kick();
      }, { passive: true });
    }
  }

  function boot() { document.querySelectorAll('[data-h3d]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector && e.target.querySelector('[data-h3d]');
    if (s) init(s);
  });
})();
